import React from 'react'
import IconButton from 'material-ui/IconButton'
import Icon from 'material-ui/Icon'
import { saveToExcel } from '../helpers'

const DownloadButton = props => {
  return (
    <span title={props.tooltip || 'Download'}>
      <IconButton
        onClick={
          props.onClick || (() => saveToExcel(props.data, props.fileName))
        }
      >
        <Icon>{props.icon || 'file_download'}</Icon>
      </IconButton>
    </span>
  )
}

export default DownloadButton



// WEBPACK FOOTER //
// ./src/core/components/DownloadButton.js